import { autoinject, bindable } from 'aurelia-framework';
import { Coupling } from 'models/Connections';

@autoinject
export class CouplingForm {
  @bindable() protected coupling: Coupling;
}
